<template>
  <section class="categories">
    <div>
      <Tabs value="全部" @on-click="handleTabChange">
        <TabPane
          v-for="category in categories"
          :key="category.name"
          :label="category.name"
          :name="category.name"
        >
        </TabPane>
      </Tabs>
      <div class="tab-content">
        <div v-if="jobPageData.length === 0" class="noDataclass">
          <div v-if="nodataState && renderingCompleted">
            <img class="noDataImg" src="https://www.mgadmob.com/mp//img/noData.png"></img>
            <div class="noDataTitle">{{ noMessage }}</div>
          </div>
        </div>
        <div v-else>
          <div class="rent-item" v-for="(item,index) in jobPageData" :key="index">
            <div style="width: 100%;">
              <div class="rent-info">
                <div class="rent-info-one">
                  <div class="rent-info-label-title"> {{ item.title }}</div>
                  <div class="rent-info-label-money"> {{ getDescByStatus(item) }}</div>
                </div>
                <div class="rent-info-tag">
                  <div class="rent-info-tagtagtitle">{{ item.city }}</div>
                  <div class="rent-info-tagtagdivider"></div>
                  <div class="rent-info-tagtagtitle">{{ item.payMethod }}</div>
                  <div class="rent-info-tagtagdivider"></div>
                  <div class="rent-info-tagtagtitle">{{ item.salary }}{{ item.salaryUnit }}</div>
                </div>
                <div class="rent-info-apply">
                  <div v-if="isVip()">剩余报名额度：会员不限</div>
                  <div v-else>剩余报名额度：{{getRemainApplyNum(item)}}</div>
                </div>
                <div style="width: 100%;height: 1px;background-color: #EEEEEE" v-if="item.checkStatus != 2">
                </div>
                <div class="rent-info-bottom" v-if="item.checkStatus != 2">
                  <div class="rent-info-tips">
                    <div v-if="item.checkStatus == 5 && item.offlineReason== 1 && isVip()">
                      在线职位权益不足，已自动下线</div>
                    <div v-if="item.checkStatus == 5 && getRemainApplyNum(item) == 0 && !isVip()">
                      当前职位报名额度为0，已自动下线</div>
                  </div>
                  <div style="display: flex;flex-direction: row;margin-left: auto;">
                    <a class="rent-info-tagtagsubmit"
                       v-if="item.checkStatus != 0 && item.checkStatus != 2 && !isVip()"
                       @click="recharge(item)">充值
                    </a>
                    <a class="rent-info-tagtagedit" v-if="item.checkStatus != 0" @click="edit(item)">编辑岗位
                    </a>
                    <a class="rent-info-tagtagsubmit" v-if="item.checkStatus != 3"
                       @click="sureClick(item)">
                      {{ getSureBtnText(item) }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row v-if="jobPageData.length !== 0">
        <Col :md="24" class="pagination">
          <Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="!renderingCompleted"
                @on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total
                :page-size-opts="[5, 10]"/>
        </Col>
      </Row>
      <CenterDialog
        :visible.sync="isShowBd"
        type="image"
        width="350px"
        :image="imageQrcode"
        :showActions="false"
      />
      <CenterDialog
        :visible.sync="showToBProgram"
        type="image"
        width="240px"
        title="请前往小程序继续操作"
        :image="imageQrcodeToB"
        :showActions="false"
      />
    </div>
  </section>
</template>

<script>
import api from "@/api";
import CenterDialog from "@/views/toc/ShowImageDialog.vue";

export default {
  name: 'positionList',
  components: {CenterDialog},
  data() {
    return {
      categories: [{
        name: '全部',
        dictType: null
      }, {
        name: '招聘中',
        dictType: '4'
      }, {
        name: '待发布',
        dictType: '1'
      }, {
        name: '待支付',
        dictType: '0'
      }, {
        name: '审核失败',
        dictType: '3'
      }, {
        name: '审核中',
        dictType: '2'
      }, {
        name: '已下线',
        dictType: '5'
      }],
      jobPageData: [],
      nodataState: false,
      renderingCompleted: false,
      noMessage: '暂无岗位',
      totalRecord: 1,
      pageNum: 1,
      pageSize: 10,
      checkStatus: null,
      isShowBd: false,
      showToBProgram: false,
      imageQrcode: "https://www.mgadmob.com/mp/img/postImage.png",
      imageQrcodeToB: require("@/assets/img/qrcode_shangjia.jpg"),
      vipInfo: null,
    };
  },
  created() {
    this.getData()
    this.getVipInfo()
  },
  methods: {
    pageChange(pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
    },
    handleTabChange(name) {
      this.checkStatus = this.categories.filter((item) => {
        return item.name === name
      })[0].dictType
      this.getData()
    },
    getDescByStatus(item) {
      if (item.checkStatus == 0) {
        return '待支付'
      } else if (item.checkStatus == 1) {
        return '待发布'
      } else if (item.checkStatus == 2) {
        return '审核中'
      } else if (item.checkStatus == 3) {
        return '审核失败'
      } else if (item.checkStatus == 4) {
        return '招聘中'
      } else {
        return '已下线'
      }
    },
    //编辑
    edit(item) {
      this.$router.replace({
        name: 'postjobstep2',
        params: {
          jobId: item.id,
        }
      });
    },
    getSureBtnText(item) {
      if (item.checkStatus == 0) {
        return '支付'
      } else if (item.checkStatus == 4) {
        return '下线职位'
      } else {
        return '发布'
      }
    },
    sureClick(item) {
      if (item.checkStatus == 0) { //去支付
        //先查看是否是 vip
        this.showToBProgram = true
      } else if (item.checkStatus == 1) { //待发布
        this.pushBusinessPublishJobToCheck(item)
      } else if (item.checkStatus == 4) { //招聘中
        this.onlineOrOfflineToBJob(item.id, 0)
      } else if (item.checkStatus == 5) { //已下线
        this.onlineOrOfflineToBJob(item.id, 1)
      }
    },
    pushBusinessPublishJobToCheck(item) {
      api.statistics
        .pushBusinessPublishJobToCheck(item.id)
        .then(res => {
          if (res.code == 2000) {
            if (res.data.success != true) {
              this.$Message.error('职位发布失败，请稍后重试');
            } else if (res.data.vipCheckResult.needPay == true) {
              if (res.data.vipCheckResult.needPayReason == 1 || res.data.vipCheckResult
                .needPayReason == 2) {
                //去 Vip 页面购买
                this.showToBProgram = true
              } else if (res.data.vipCheckResult.needPayReason == 3) {
                this.isShowBd = true;
              }
            } else {
              this.getData()
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    recharge(){
      this.showToBProgram = true
    },
    onlineOrOfflineToBJob(id, onlineOrOffline) {
      let params = {
        id: id,
        onlineOrOffline: onlineOrOffline
      }
      api.statistics
        .onlineOrOfflineBusinessPublishJob(params)
        .then(res => {
          if (res.code == 2000) {
            if (res.data.success == true) {
              this.getData()
              if (onlineOrOffline == 1) {
                this.$Message.success('发布职位成功');
              } else {
                this.$Message.success('下线职位成功');
              }
            } else if (res.data.vipCheckResult.needPay == true) {
              if (res.data.vipCheckResult.needPayReason == 1 || res.data.vipCheckResult
                .needPayReason == 2) {
                //去 Vip 页面购买
                this.showToBProgram = true
              } else if (res.data.vipCheckResult.needPayReason == 3) {
                this.isShowBd = true;
              }
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getVipInfo() {
      api.statistics
        .getVipInfo()
        .then(res => {
          if (res.code == 2000) {
            if (res.data.length > 0) {
              this.vipInfo = res.data[res.data.length - 1]
            }
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getData() {
      this.renderingCompleted = false
      const queryParams = {
        page: this.pageNum,
        limit: this.pageSize,
        checkStatus: this.checkStatus,
      }
      api.statistics
        .getPostJobList(queryParams)
        .then(res => {
          if (res.code == 2000) {
            const result = res.data || {}
            this.totalRecord = result.total || 0
            this.jobPageData = result.data
            if (this.pageNum == 1 && this.jobPageData.length == 0) {
              this.nodataState = true
            }
          } else {
            this.$Message.error(res.msg)
          }
          this.renderingCompleted = true
        })
        .catch(error => {
          this.renderingCompleted = true
          console.error('请求出错：', error)
        })
    },
    isVip() {
      return this.vipInfo != null && this.vipInfo.isEffective == true
    },
    getRemainApplyNum(item) {
      return item.totalApplyNum - item.useApplyNum
    },
  }
}
</script>

<style scoped>
.categories {
  padding: 80px 60px;
}

h2 {
  font-size: 32px;
  margin-bottom: 40px;
  text-align: center;
}

.tab-content {
  padding: 30px 0px;
  display: flex;
  flex-direction: column;
}

/* 1. 移除 Tab 标签栏底部的边框 */
.categories >>> .ivu-tabs-bar {
  border-bottom: none !important;
  margin-bottom: 0 !important;
}


/* 2. 禁用 View-Design 自带的墨条 */
.categories >>> .ivu-tabs-ink-bar {
  display: none !important;
}

/* 3. Tab 标签样式基础设置 */
.categories >>> .ivu-tabs-nav .ivu-tabs-tab {
  font-size: 15px;
  padding: 8px 5px;
}

/* 4. 设置选中（激活）状态的文字样式 */
.categories >>> .ivu-tabs-nav .ivu-tabs-tab-active {
  color: #4295FD !important;
  font-weight: bold !important;
}

/* 5. 创建自定义短横条 (伪元素) */
.categories >>> .ivu-tabs-nav .ivu-tabs-tab-active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%; /* 从中心开始 */

  /* 关键：设置短横条的宽度和颜色 */
  width: 30px; /* 💡 固定宽度，您可以调整 */
  height: 3px;
  background-color: #4295FD;

  /* 居中对齐 */
  transform: translateX(-50%);
  transition: all 0.3s ease-in-out;
}

.categories >>> .ivu-tabs-nav-container {
  margin: 0 auto !important;
  display: flex !important; /* 强制容器使用 Flex */
  justify-content: left !important; /* 强制 Flex 子项（标签列表）居中 */
}

.noDataclass {
  text-align: center;
  margin-top: 15%;
}

.noDataImg {
  width: 83px;
  height: 94px;
}

.noDataTitle {
  font-size: 20px;
  color: #BEBEBE;
  margin-top: 20px;
}

.rent-item {
  border-radius: 14px;
  display: flex;
  margin-bottom: 10px;
  background: white;
  padding: 15px;
}

.rent-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.rent-info-one {
  display: flex;
}

.rent-info-label-title {
  font-size: 18px;
  overflow: hidden;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #383434;
}

.rent-info-label-money {
  font-size: 16px;
  color: #333333;
  margin-left: auto;
}

.rent-info-tag {
  display: flex;
  margin-bottom: 7px;
  align-items: center;
}

.rent-info-tagtagtitle {
  font-size: 15px;
  color: #7b7b7b;
}

.rent-info-apply {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  font-size: 28rpx;
  color: #333333;
}

.rent-info-tagtagdivider {
  width: 1px;
  height: 18px;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #C4C4C4;
}

.rent-info-bottom {
  margin-top: 15px;
  display: flex;
  align-items: center;
}

.rent-info-tips {
  margin-top: 30rpx;
  margin-bottom: 15rpx;
  color: #FA5151;
  font-size: 28rpx;
}

.rent-info-tagtagedit {
  text-align: center;
  margin-left: 20px;
  width: 80px;
  font-size: 14px;
  padding: 5px 0px;
  color: #33D0B2;
  background-color: white;
  border-radius: 5px;
  border-color: #33D0B2;
  border-width: 1px;
  border-style: solid;
}

.rent-info-tagtagsubmit {
  text-align: center;
  width: 80px;
  margin-left: 15px;
  font-size: 14px;
  padding: 5px 0px;
  color: white;
  background-color: #33D0B2;
  border-radius: 5px;
}


</style>
